export default __webpack_public_path__ + "static/media/1862.7cc1fd82.png";